// extracted by mini-css-extract-plugin
export default {"playerTopBar":"PlayerWorkBox_playerTopBar__hvaTh","idleAnimationContainer":"PlayerWorkBox_idleAnimationContainer__SzOtk"};